import { useEffect } from 'react';
import { useExperiment, useGrowthBook } from '@growthbook/growthbook-react';
import { logEvent } from '../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../lib/shared/event-types';

function useABExperiment({ key, userPropertyName }) {
    const gb = useGrowthBook();
    const { value } = useExperiment({ key, variations: ['control', 'variant'] });

    useEffect(() => {
        if (gb?.ready && userPropertyName) {
            logEvent(EVENT_TYPES.USER_PROPERTIES, { [userPropertyName]: value });
        }
    }, [gb?.ready]);

    return {
        isReady: Boolean(gb?.ready),
        isVariant: Boolean(gb?.ready && value === 'variant')
    };
}

export {
    useABExperiment
};
